import React from 'react'
import {Modal} from 'react-bootstrap'
import { SubmissionError } from 'redux-form'
import _ from 'lodash'
import AddUserForm from './AddUserForm'
import {createOtherUser2} from '../../../../actions/index'

const AddUserModal = (props) => {

    const onCancel = (e) => {
        e.preventDefault();
        props.onCancel();
    }

    const handleSubmit = (values) => {
        //console.log('handleSubmit', values)

        _.forEach([`name`, `phone`, `email`, `password`], k => {
            if (!values[k]) {
                throw new SubmissionError({ _error: 'Fill out all the fields' })
            }
        })

        values.groupId = (props.group || {}).id

        console.log('user', values)
        props.dispatch(createOtherUser2(values))
        props.onCancel()
    }

    //console.log('render AddUserModal')
    return <div className="vertical-alignment-helper">
        <div className="modal-dialog vertical-align-center">
            <Modal.Dialog>
                <Modal.Header>
                    <Modal.Title>CREATE NEW USER</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <AddUserForm onCancel={onCancel} onSubmit={handleSubmit}/>
                </Modal.Body>

                <div className="green-bottom"/>
            </Modal.Dialog>
        </div>
    </div>
}

export default AddUserModal


// WEBPACK FOOTER //
// ./src/components/admin/groups/Users/AddUserModal.jsx